





















import { Component, Vue, Prop } from 'vue-property-decorator'
import Axios from 'axios'
import { sentryException } from '@/system/sentry'
import { SUBSCRIPTION_TYPES, CURRENCIES } from '@/constants'

@Component({})
export default class PaymentMollie extends Vue {
  @Prop()
  selectedPlan: SUBSCRIPTION_TYPES

  @Prop()
  currency: CURRENCIES

  @Prop()
  voucherCode: string

  loading: boolean = false

  async generatePaymentLink() {
    if (this.loading) return

    this.loading = true

    try {
      const { data: { link } } = await Axios.post('/user/payment-link', {
        subscriptionType: this.selectedPlan,
        currency: this.currency,
        voucherCode: this.voucherCode
      })

      this.$ga.event('subscription', 'payment_requested')

      location.href = link
    } catch (error) {
      sentryException(error)

      this.loading = false
    }
  }
}
